import { apiRequest } from '@/lib/api';

export interface Call {
  id: string;
  started_at: string;
  ended_at: string | null;
  user_phone: string;
  direction: string;
  duration_seconds: number | null;
  call_outcome: string | null;
  call_language: string | null;
  call_type: string | null;
  sentiment: string | null;
  summary_he: string | null;
  summary_en: string | null;
  agent_id: string | null;
  client_id: string | null;
  agents: { name: string } | null;
}

export interface CallDetail extends Call {
  transcript: Array<{ role: string; content: string; timestamp?: string }> | null;
  recording_url: { service?: string; source?: string } | null;
  recording_sid: string | null;
  action_items_structured: Array<{ text?: string; description_en?: string; description_he?: string; type?: string; priority?: string }>;
  captured_data: Record<string, string>;
  summary_raw: Record<string, unknown> | null;
  promises_made: Array<{ text: string; deadline?: string }>;
  survey_question: string | null;
  survey_response: string | null;
}

export interface CallListResponse {
  data: Call[];
  total: number;
  offset: number;
  limit: number;
}

export interface CallFilters {
  offset?: number;
  limit?: number;
  agent_id?: string;
  direction?: string;
  phone?: string;
  date_from?: string;
  date_to?: string;
}

export async function getCalls(filters: CallFilters = {}): Promise<CallListResponse> {
  const params = new URLSearchParams();
  if (filters.offset) params.set('offset', String(filters.offset));
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.agent_id) params.set('agent_id', filters.agent_id);
  if (filters.direction) params.set('direction', filters.direction);
  if (filters.phone) params.set('phone', filters.phone);
  if (filters.date_from) params.set('date_from', filters.date_from);
  if (filters.date_to) params.set('date_to', filters.date_to);

  const query = params.toString();
  return apiRequest<CallListResponse>(`/calls${query ? `?${query}` : ''}`);
}

export async function getCallDetail(callId: string): Promise<CallDetail> {
  return apiRequest<CallDetail>(`/calls/${callId}`);
}
